import { useState } from "react";
import { RegistrationStart } from "./RegistrationStart";
import { RegistrationSuccess } from "./RegistrationSuccess";
import { RegistrationLoading } from "./RegistrationLoading";
import { RegistrationConfirmEmail } from "./RegistrationConfirmEmail";
import { RetryScreen } from "../retry/RetryScreen";

export type RegistrationStep = "confirmEmail" | "start" | "registering" | "success" | "error";

export const RegistrationScreen = () => {
    const [registrationStep, setRegistrationStep] = useState<RegistrationStep>("confirmEmail");
    const [error, setError] = useState<string | undefined>();
    const onRetryScreenRetry = () => setRegistrationStep("start");

    switch (registrationStep) {
        case "confirmEmail":
            return <RegistrationConfirmEmail setRegistrationStep={setRegistrationStep} />;
        case "start":
            return <RegistrationStart setRegistrationStep={setRegistrationStep} setError={setError} />;
        case "registering":
            return <RegistrationLoading />;
        case "success":
            return <RegistrationSuccess />;
        case "error":
            return <RetryScreen data-testid="registration-error-view" message={error} onRetry={onRetryScreenRetry} />;
    }
};
